import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PaymentActions, ProjectsActions, authActions } from 'redux/actions';
import {
  SvgWrapper,
  Container,
  H1,
  IsLoggedIn,
  Colors,
  isMobile,
  Modal,
  device,
  Section,
} from 'utils';
import { default as ShareProject } from './ShareProjct';
import { Header, Footer, Card, SingUpFormV2 } from 'components';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import config from 'config';
import { Spin } from 'antd';
import { ThankYouImgNew, ThankYouPromoImg, ThankYouBGImg } from 'images';
import MuhammedSAW from 'components/MuhammadSaw';
import SawBlack from '../../images/Black-sallallahu-alaihi-wasallam.png';
import ContactModal from 'scenes/Project/components/ContactModal';
import DonationTable from './DonationTable';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import projectServices from '../../services/ProjectsServices';
import {
  getProjectDestination,
  isSpecialProjectUrl,
} from './projectDestination';

const APP_URL = config.REACT_APP_URL;

const MobileBreak = styled.span`
  display: none;
  @media ${device.allMobile} {
    display: block;
  }
`;

const DesktopBreak = styled.span`
  display: block;
  @media ${device.allMobile} {
    display: none;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  @media ${device.allMobile} {
    display: block;
  }
  .card {
    width: 32%;
    display: inline-block;
    text-align: center;
    margin-bottom: 65px;
    @media ${device.allMobile} {
      width: 90%;
      margin: auto;
      margin-bottom: 20px;
    }
  }
`;

const ThankYouPageWrapper = styled.div`
  background: #fff;
  min-height: 100vh;
  padding: 30px 0 60px 0;
  color: ${Colors.white};
  text-align: center;
  position: relative;
  overflow: hidden;
  @media ${device.allMobile} {
    padding: 20px 0 60px 0;
  }

  .thank-you-img {
    width: 100%;  
    max-width: 326px;
    max-height: 326px;
    margin-bottom: 24px;
    @media ${device.allMobile} {
      top: 8%;
      width: 100%;  
      max-width: 200px;
      max-height: 200px;
      margin-bottom: 16px;
    }
  }
  .thank-you-bg-img {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
    pointer-events: none;
    @media ${device.allMobile} {
      overflow: hidden;
      width: 170%;
      max-width: 170%;
      max-height: 130%;
      object-fit: cover;
      object-position: center;
      position: absolute;
      top: 8%;
      left: 50%;
      transform: translateX(-50%);
    }

  }
`;

const ThankYouHeading = styled.h1`
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 600;
  color: #181D27;
  margin-bottom: 10px;
  @media ${device.allMobile} {
    font-size: 24px;
    margin-bottom: 6px;
  }
`;

const ThankYouSubtext = styled.p`
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #535862;
  margin-bottom: 10px;
  @media ${device.allMobile} {
    font-size: 16px;
    margin-bottom: 6px;
  }
`;

const ShareCallToAction = styled.p`
  font-size: 18px;
  color: #535862;
  margin-bottom: 20px;
  @media ${device.allMobile} {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .highlight {
    color: #3F621A;
    font-weight: 600;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 48px;
  position: relative;
  z-index: 2;
  @media ${device.allMobile} {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  button {
    margin-bottom: 0;
    height: 48px;
    line-height: 0;
    @media ${device.allMobile} {
    height: unset;
    line-height: unset;
    }
  }
`;

const PaymentSummaryWrapper = styled.div`
  max-width: 582px;
  margin: 0 auto;
  text-align: left;
  margin-bottom: 48px;
  position: relative;
  z-index: 1;
`;

const PromoCardWrapper = styled.div`
  max-width: 1216px;
  margin: 0 auto 48px;
  background: #F5FBEE;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  align-items: center;
  gap: 32px;
  position: relative;
  z-index: 1;
  @media ${device.allMobile} {
    flex-direction: column;
    padding: 20px;
    gap: 20px;
  }
`;

const PromoIllustration = styled.div`
  flex-shrink: 0;
  width: 100%;
  min-width: 370px;
  max-width: 370px;
  @media ${device.allMobile} {
  min-width: unset;
  width: 100%;


  }
  .promo-img{
    width: 100%;
    max-width: 279px;
    max-height: 199px;
    margin-left: auto;
    display: block;
    @media ${device.allMobile} {
    margin-left: auto;
    margin-right: auto;
    }
  }
`;

const PromoContent = styled.div`
  flex: 1;
  text-align: left;
  max-width: 657px;
  button {
    margin: 0;
    height: 48px;
    line-height: 0;
    min-width: 261px;
  }
`;

const PromoHeading = styled.h3`
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #2B4212;
  margin: 0 0 4px 0;
  @media ${device.allMobile} {
    font-size: 22px;
    text-align: center !important;
    color: #181D27;
  }
`;

const PromoText = styled.p`
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #2B4212;
  margin: 0 0 24px 0;
  line-height: 28px;
  @media ${device.allMobile} {
    font-size: 14px;
    margin-bottom: 16px;
    text-align: center !important;
    color: #181D27;
  }
  .highlight {
    font-weight: 600;
  }
`;

const QuoteSectionWrapper = styled.div`
  max-width: 1216px;
  margin: 0 auto;
  background: ${Colors.white};
  padding-top: 32px;
  text-align: center;
  @media ${device.allMobile} {
    padding: 40px 20px;
  }
`;

const QuoteText = styled.p`
  font-family: 'Crimson Text', 'Times New Roman', serif;
  font-size: 24px;
  font-weight: 600;
  color: #181D27;
  line-height: 1.6;
  margin: 0 0 20px 0;
  max-width: 811px;
  margin-left: auto;
  margin-right: auto;
  @media ${device.allMobile} {
    font-size: 20px;
    margin-bottom: 20px;
  }
  @media ${device.tablet} {
    font-size: 24px;
  }
`;

const QuoteAttribution = styled.p`
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 16px;
  font-weight: 400;
  color: #181D27;
  margin: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${device.allMobile} {
    font-size: 16px;
  }
`;

const PaymentSummaryTitle = styled.h2`
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #181D27;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #D5D7DA;
  @media ${device.allMobile} {
    font-size: 18px;
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 16px;
  }
`;

const ProjectLabelMobile = styled.div`
  display: none;
  @media ${device.allMobile} {
    display: block;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #535862;
    margin-bottom: 4px;
    text-align: left;
  }
`;

const ProjectTitleMobile = styled.div`
  display: none;
  @media ${device.allMobile} {
    display: block;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #181D27;
    margin-bottom: 12px;
    text-align: left;
  }
`;

const PaymentSummaryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  tr {
    border-bottom: 1px solid #E9EAEB;
    &:last-child {
      border-bottom: none;
    }
  }
  td {
    padding: 12px 160px 12px 0; 
    font-size: 16px;
    color: #535862;
    font-weight: 400;

    &:first-child {
      color: #535862;
      font-weight: 400;
      min-width: 250px;
    }
    .highlight {
      color: #181D27;
      font-weight: 600;
    }
  }
  @media ${device.allMobile} {
    td {
      font-size: 14px;
      padding: 12px 0;
      padding-right: 16px;
      &:first-child {
        min-width: 150px;
      }
      &:last-child {
        padding-right: 30px;
      }
    }
    tr.project-row {
      display: none;
    }
  }
`;

const RecommendedProjectsWrapper = styled.div`
  padding: 0 0;
  text-align: center;
  position: relative;
  margin-top: -5vh;

  h1 {
    position: relative;
    margin-bottom: 80px;
    font-weight: bold;
    @media ${device.laptop} {
      font-size: 32px;
    }
    &:after {
      content: '';
      width: 300px;
      height: 4px;
      background: ${Colors.secondaryColor};
      display: inline-block;
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  & > a {
    display: inline-block;
    text-decoration: none;
    margin: 20px auto 0;
    color: ${Colors.secondaryColor};
  }
  .show-more {
    font-weight: bold;
    font-size: 22px;
  }

  .show-more-wrapper {
    position: relative;
    .background {
      position: absolute;
      z-index: -1;
      width: 100%;
      top: -50%;
    }
  }
  .show-more-component {
    display: flex;
    align-items: center;
    @media ${device.allMobile} {
      display: block;
    }
    &__content {
      margin-left: 45px;
      text-align: left;
      @media ${device.allMobile} {
        text-align: center;
        margin-left: 0;
      }
      h2 {
        font-weight: bold;
        font-size: 45px;
        margin: 0;
        @media ${device.allMobile} {
          font-size: 25px;
        }
        @media ${device.laptop} {
          font-size: 32px;
        }
        @media ${device.tablet} {
          font-size: 28px;
        }
      }
      p {
        font-size: 30px;
        @media ${device.allMobile} {
          font-size: 16px;
        }
        @media ${device.laptop} {
          font-size: 20px;
        }
        span {
          display: block;
          a {
            text-decoration: underline;
            &:hover {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
`;

const ThankYouButton = styled.button`
  border-bottom: none;
  font-weight: bold;
  background: ${Colors.white};
  border: 1px solid #D5D7DA;
  color: #414651;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 15px 20px;
  min-width:  '200px';
  font-size: 22px;
  @media ${device.laptop} {
    font-size: 16px;
    min-width: '100px';
  }
  @media ${device.allMobile} {
    min-width: 100%;
    padding: 10px 20px;
    font-size: 16px;
    background: ${Colors.white};
    border: 1px solid #D5D7DA;
    color: #414651;
  }
  &:hover {
    background: ${Colors.secondaryColor};
    color: ${Colors.white};
  }
  &:disabled {
    background: ${Colors.steel};
    border: ${Colors.steel};
    color: ${Colors.grey};
    cursor: not-allowed;
  }
`;

const PrimaryButton = styled.button`
  border-bottom: none;
  font-weight: bold;
  background: ${Colors.newSecondaryColor};
  border: 1px solid ${Colors.steel};
  color: ${Colors.white};
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 15px 20px;
  min-width: 200px;
  font-size: 22px;
  @media ${device.laptop} {
    font-size: 16px;
    min-width: 200px;
  }
  @media ${device.allMobile} {
    min-width: 100% !important;
    padding: 10px 20px;
    font-size: 16px;
    background: ${Colors.newSecondaryColor};
    border: 1px solid #D5D7DA;
    color: ${Colors.white};
  }
  &:hover {
    background: ${Colors.white};
    color: ${Colors.newSecondaryColor};
  }
  &:disabled {
    background: ${Colors.steel};
    border: ${Colors.steel};
    color: ${Colors.grey};
    cursor: not-allowed;
  }
`;

class ThankYouPage extends Component {
  componentDidMount() {
    const {
      resetDonation,
      project,
      showProject,
      sendSuccessURL,
      match: {
        params: { url },
      },
    } = this.props;

    resetDonation();
    const searchParams = new URLSearchParams(
      this.props.location?.search || ''
    );
    const queryUrl = searchParams.get('url');
    const projectUrl = [url, queryUrl].find(
      (value) =>
        value != null &&
        value !== '' &&
        String(value).trim() !== 'undefined'
    );

    if (
      projectUrl &&
      !isSpecialProjectUrl(projectUrl) &&
      project?.url !== projectUrl
    ) {
      showProject(projectUrl, true, true, true);
    }
    const session_id = searchParams.get('session_id');
    if (session_id && sendSuccessURL) {
      sendSuccessURL(session_id);
    }
    this.handleSetProject();
    this.handleShowProjects();
  }

  static propTypes = {
    resetDonation: PropTypes.func.isRequired,
    showProject: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object,
    sendSuccessURL: PropTypes.func,
    projects: PropTypes.object.isRequired,
    getProjects: PropTypes.func.isRequired,
  };
  state = {
    showModal: false,
    showSignupModal: false,
    projectObj: {},
    perPage: 0,
    allProjectsIds: [],
    allProjects: [],
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.projects !== this.props.projects) {
      const combinedArr = this.state.allProjects.concat(
        this.props.projects.projects
      );
      const previousIds = combinedArr?.map((project) => project.id);
      this.setState({ allProjects: combinedArr });
      this.setState({ allProjectsIds: previousIds });
    }
  };

  handleSetMetaTags = () => {
    const { projectObj } = this.state;

    if (!projectObj) {
      return;
    }
    const { title, description, images } = projectObj;
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    // const ogImageTag = document.querySelector('meta[property="og:image"]');
    // const ogImageTagSecure = document.querySelector('meta[property="og:image:secure_url"]');
    const projectUrl = document.querySelector('meta[property="og:url"]');
    if (ogTitleTag && title) {
      ogTitleTag.setAttribute('content', title);
    }
    if (ogDescriptionTag && description) {
      ogDescriptionTag.setAttribute('content', description);
    }
    if (projectUrl) {
      const project_url = `${APP_URL}project/${projectObj?.url ? projectObj?.url : ''
        }`;
      projectUrl.setAttribute('content', project_url);
    }
    // if (ogImageTag && ogImageTagSecure && images && images.length > 0) {
    //   const projectImageURL = `${images[0]}`;
    //   if (ogImageTag) {
    //     ogImageTag.setAttribute('content', projectImageURL);
    //   }
    //   if (ogImageTagSecure) {
    //     ogImageTagSecure.setAttribute('content', projectImageURL);
    //   }
    // }
  };

  handleShowProjects = () => {
    const { getProjects } = this.props;
    const { perPage, allProjectsIds } = this.state;
    getProjects(perPage + 6, 1, allProjectsIds);
    this.setState({ perPage: perPage + 6 });
  };

  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };
  handelCloseSignupModal = () => {
    this.setState({ showSignupModal: false });
    document.body.style.overflowY = 'unset';
  };
  handelShowSignupModal = () => {
    this.setState({ showSignupModal: true });
    document.body.style.overflowY = 'hidden';
  };
  handleProfileButtonClick = () => {
    if (IsLoggedIn()) {
      window.location.href = '/profile';
    } else {
      this.handelShowSignupModal();
    }
  };
  handleProjectButtonClick = async () => {
    const { project, location, match } = this.props;
    const search = location?.search || '';
    const queryParams = new URLSearchParams(search);
    const urlFromQuery = queryParams.get('url');
    const urlFromParams = match?.params?.url;
    const projectUrl = urlFromQuery || urlFromParams || project?.url;
    const projectId = project?.id || queryParams.get('id');

    if (IsLoggedIn()) {
      if (projectUrl) {
        window.location.href = getProjectDestination(projectUrl);
        return;
      }

      if (projectId) {
        try {
          const response = await projectServices.getProjectUrl(projectId);
          if (response?.url) {
            window.location.href = `/project/${response.url}`;
          }
        } catch (_) {}
      }
    } else {
      this.handelShowSignupModal();
    }
  };
  handleSetProject = () => {
    const { project } = this.props;
    this.setState({ projectObj: project && project });
  };
  getStoredTips = () => {
    const stored = localStorage.getItem('tips');
    if (stored == null || stored === 'null') return '';
    try {
      return JSON.parse(stored);
    } catch {
      return '';
    }
  };

  getDonationData = () => {
    const { location, project } = this.props;
    const search = location?.search || '';
    const queryParams = new URLSearchParams(search);

    const titleParam = queryParams?.get('title');
    const title =
      titleParam && titleParam !== 'null' && titleParam !== 'undefined'
        ? titleParam
        : JSON.parse(localStorage.getItem('after_redirect') ?? '{}')
          ?.projectTitle ?? project?.title ?? '';

    const urlAmount = queryParams?.get('amount');
    let amount = '';
    if (urlAmount != null && urlAmount !== '') {
      amount = urlAmount;
    } else {
      const storedAmountRaw = localStorage.getItem('amount');
      if (storedAmountRaw != null && storedAmountRaw !== 'null') {
        try {
          const parsed = JSON.parse(storedAmountRaw);
          if (parsed != null && parsed !== '') amount = String(parsed);
        } catch (_) { }
      }
    }

    const urlTips = queryParams?.get('tips');
    const urlTipsNum = urlTips != null && urlTips !== '' ? Number(urlTips) : NaN;
    const storedTips = this.getStoredTips();
    const storedTipsNum = storedTips !== '' ? Number(storedTips) : 0;
    // Prefer URL only when it has a real tip; if URL has tips=0 but localStorage has a tip, use localStorage
    const tips =
      !Number.isNaN(urlTipsNum) && urlTipsNum > 0
        ? urlTips
        : storedTipsNum > 0
          ? String(storedTips)
          : urlTips != null && urlTips !== ''
            ? urlTips
            : String(storedTips ?? '');
    const id = queryParams?.get('id') ?? project?.id ?? '';
    const g = queryParams?.get('g') ?? '';
    const localGoodies = localStorage.getItem('goodies');
    const goodies = g
      ? g.split(',')
      : localGoodies && localGoodies.length
        ? localGoodies.split(',').filter((v) => v !== '' && v !== 'null')
        : [];

    const goodiesTotal = goodies.reduce((a, b) => Number(a) + Number(b), 0);
    const freeSupport = tips || '0';
    const total = amount
      ? Number(amount) + Number(tips || 0) + goodiesTotal
      : 0;

    const toDisplayAmount = (val) =>
      (val != null && val !== '' && !Number.isNaN(Number(val)))
        ? Number(val).toFixed(2)
        : '0.00';

    return {
      title,
      amount: toDisplayAmount(amount),
      tips: toDisplayAmount(tips),
      goodies: goodies.map((g) => toDisplayAmount(g)),
      goodiesTotal: goodiesTotal.toFixed(2),
      freeSupport: toDisplayAmount(freeSupport),
      total: total.toFixed(2),
      id,
    };
  };

  render() {
    const { showModal, projectObj, allProjects } = this.state;
    const { loading, project } = this.props;
    const projects = isMobile() ? allProjects.slice(0, 3) : allProjects;
    const donationData = this.getDonationData();

    return (
      <>
        <ContactModal />
        <div>
          <Header relativeHeader={true} />
          <ThankYouPageWrapper>
            <Container>
              <img
                src={ThankYouImgNew}
                alt="thank-you-img"
                className="thank-you-img"
              />

              <ThankYouHeading>
                Vielen Dank für
                <MobileBreak /> deinen wertvollen Beitrag!
              </ThankYouHeading>

              <ThankYouSubtext>
                Deine Unterstützung ist eingegangen und
                <MobileBreak /> stärkt dieses Projekt direkt.
              </ThankYouSubtext>

              <ShareCallToAction>
                <span className="highlight">Teile das Projekt jetzt</span> -
                durch dein
                <MobileBreak /> Teilen können
                <DesktopBreak /> durchschnittlich
                <MobileBreak /> <span className="highlight">34 €</span>{' '}
                zusätzlich eingehen.
              </ShareCallToAction>

              <ButtonsWrapper>
                {IsLoggedIn() ? (
                  <ThankYouButton
                    primary={true}
                    onClick={this.handleProjectButtonClick}
                    minWidth="100%"
                  >
                    Zum Projekt
                  </ThankYouButton>
                ) : (
                  <ThankYouButton
                    primary={true}
                    onClick={this.handleProfileButtonClick}
                    minWidth="100%"
                  >
                    Profilerstellung abschließen
                  </ThankYouButton>
                )}

                <PrimaryButton onClick={this.handelShowModal} minWidth="100%">
                  Teilen
                </PrimaryButton>
              </ButtonsWrapper>
              <img
                src={ThankYouBGImg}
                alt="thank-you-img"
                className="thank-you-bg-img"
              />

              <PaymentSummaryWrapper>
                <div style={{ display: 'none' }}>
                  <DonationTable />
                </div>
                <PaymentSummaryTitle>Zahlungsübersicht</PaymentSummaryTitle>
                <ProjectLabelMobile>Projekt</ProjectLabelMobile>
                <ProjectTitleMobile>
                  {donationData?.title === 'dhullhijjah2026' ? 'Deine tägliche Dhull-Hijjah Sadaqah' : donationData?.title}
                </ProjectTitleMobile>
                <PaymentSummaryTable>
                  <tbody>
                    <tr className="project-row">
                      <td>Projekt</td>
                      <td>
                        <span className="highlight">
                          {donationData?.title === "dhullhijjah2026" ? "Deine tägliche Dhull-Hijjah Sadaqah" : donationData?.title}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Projekt-ID</td>
                      <td>{donationData?.id}</td>
                    </tr>
                    <tr>
                      <td>Deine Unterstützung</td>
                      <td>{donationData.amount} €</td>
                    </tr>
                    <tr>
                      <td>Dein Goodie</td>
                      <td>{donationData.goodiesTotal} €</td>
                    </tr>
                    <tr>
                      <td>Freie Unterstützung</td>
                      <td>{donationData.freeSupport} €</td>
                    </tr>
                    <tr>
                      <td>
                        <span className="highlight">Gesamt</span>
                      </td>
                      <td>
                        <span className="highlight">
                          {donationData.total} €
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </PaymentSummaryTable>
              </PaymentSummaryWrapper>
              <PromoCardWrapper>
                <PromoIllustration>
                  <img
                    src={ThankYouPromoImg}
                    alt="freitags-sadaqah-img"
                    className="promo-img"
                  />
                </PromoIllustration>
                <PromoContent>
                  <PromoHeading>Schon gewusst?</PromoHeading>
                  <PromoText>
                    Die <span className="highlight">Freitags-Sadaqah</span>{' '}
                    macht es dir leicht, deine Sadaqah regelmäßig und
                    automatisch zu geben. Ein kleiner, beständiger Beitrag mit
                    großer Wirkung für Moscheen, Bildung und Nothilfe in unserer
                    Community.
                  </PromoText>
                  <PrimaryButton
                    onClick={() => {
                      if (isMobile()) {
                        window.location.href =
                          'https://commonsplace.de/freitags-sadaqah?utm_campaign=TPM';
                      } else {
                        window.location.href =
                          'https://commonsplace.de/freitags-sadaqah?utm_campaign=TPD';
                      }
                    }}
                    minWidth="100%"
                  >
                    Freitags-Sadaqah einrichten
                  </PrimaryButton>
                </PromoContent>
              </PromoCardWrapper>

              <QuoteSectionWrapper>
                <QuoteText>
                  "Es gibt keinen Muslim, welcher ein Bäumchen oder eine
                  Nutzpflanze einpflanzt, wovon ein Vogel oder ein Mensch isst,
                  ohne dass ihm dies als Wohltätigkeit angerechnet wird."
                </QuoteText>
                <QuoteAttribution>
                  - Prophet Muhammed{' '}
                  <img
                    src={SawBlack}
                    alt="صلى الله عليه وسلم"
                    style={{
                      width: '22px',
                      height: '22px',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginLeft: '4px',
                    }}
                  />
                </QuoteAttribution>
              </QuoteSectionWrapper>
            </Container>
          </ThankYouPageWrapper>
          <RecommendedProjectsWrapper>
            <div className="container">
              <Container>
                <Section>
                  <div>
                    <H1>Weitere Projekte aus Deiner Community</H1>
                  </div>
                  <Spin spinning={loading}>
                    <CardsWrapper>
                      {projects?.length > 0 &&
                        projects?.map((project) => (
                          <Card
                            project={project}
                            key={JSON.stringify(project)}
                          />
                        ))}
                    </CardsWrapper>
                  </Spin>
                  <ExternalLink href="/projects">
                    <PrimaryButton className="show-more">
                      Mehr anzeigen
                    </PrimaryButton>
                  </ExternalLink>
                </Section>
              </Container>
            </div>
          </RecommendedProjectsWrapper>
          <Footer />
        </div>
        <Modal showModal={showModal} handelCloseModal={this.handelCloseModal}>
          <ShareProject
            subtitle={projectObj?.subtitle ? projectObj?.subtitle : ''}
            title={projectObj?.title ? projectObj?.title : ''}
            banner={projectObj?.banner ? projectObj?.banner : ''}
            url={`${APP_URL}project/${projectObj?.url ? projectObj?.url : ''}`}
          />
        </Modal>
        <Modal
          showModal={this.state.showSignupModal}
          handelCloseModal={this.handelCloseSignupModal}
          width="500px"
        >
          <SingUpFormV2
            handelCloseModal={this.handelCloseSignupModal}
            onRegisterSuccess={() => {
              this.handelCloseSignupModal();
              window.location.href = '/profile';
            }}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, homeProjects, projects } = state.projects;
  return {
    project,
    loading,
    homeProjects,
    projects,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showProject: (url, noDonations, noUpdates, noRandomProjects) =>
    dispatch(
      ProjectsActions.showProject(url, noDonations, noUpdates, noRandomProjects)
    ),
  getProjects: (perPage, page, ids) =>
    dispatch(ProjectsActions.getProjects(perPage, page, ids)),
  resetDonation: () => dispatch(PaymentActions.resetDonation()),
  sendSuccessURL: (id) => dispatch(authActions.sendSuccessURL(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThankYouPage);
